import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import SettingsScreen from "./settings-screen";
import {
    fsLogoutUser,
    fsResetEmailPassword,
    mergeAndDeleteAnonymousUser,
    saveSettings,
    toggleSound,
    toggleVibration
} from "../../ducks/duck-user";
import {
    addLoadingScreen,
    addModalWindow,
    LOGIN_SCREEN,
    RANKING_SCREEN,
    removeLoadingScreen,
    STATISTICS_SCREEN
} from "../../ducks/duck-screen";
import {playCorrectAudio, vibrateWrong} from "../../helpers/sounds";
import {
	avatarChangeModal,
	confirmDeleteModal,
	confirmResetDatabaseModal,
	confirmResetPasswordModal
} from "../../helpers/modal-builder";
import {getTranslation} from "../../helpers/get-translation";

class SettingsScreenContainer extends Component {
	componentWillUnmount(){
		if(this.props.didSettingsChange){
			const settings = this.props.settings;
			this.props.saveSettings(settings)
		}
	}

	render(){
		const {
			settings,
			appConfig,
			addModalWindow,
			toggleSound,
			toggleVibration,
			fsLogoutUser,
			displayName,
			avatar,
			isAnonymous,
			push,
			uid
		} = this.props;

		const getSocial = () => {
			return [
				{
					name: getTranslation("settings_statistics"),
					img: getTranslation("image_settings_statistics"),
					type: "button",
					onClick: () => (push(STATISTICS_SCREEN))
				},
				{
					name: getTranslation("settings_high_scores"),
					img: getTranslation("image_settings_high_scores"),
					type: "button",
					onClick: () => (push(RANKING_SCREEN))
				},
				{
					name: getTranslation("settings_like_fb"),
					img: getTranslation("image_settings_facebook"),
					isLast: true,
					type: "button",
					onClick: () => window.open(appConfig.strings.facebookUrl, "_blank"),
				}
			];
		};

		const soundOnClick = (isSoundOn) => {
			toggleSound(isSoundOn);
			if (isSoundOn) {
				playCorrectAudio()
			}
		};

		const vibrateOnClick = (isVibrationOn) => {
			toggleVibration(isVibrationOn);
			if (isVibrationOn) {
				vibrateWrong()
			}
		};

		const getOther = () => {
			return [
				{
					name: getTranslation("settings_android"),
					img: getTranslation("image_settings_android"),
                    href: appConfig.strings.appUrlAndroid,
					type: "link"
				},
				{
					name: getTranslation("settings_iOS"),
					img: getTranslation("image_settings_ios"),
                    href: appConfig.strings.appUrlIOS,
					type: "link"
				},
				{
					name: getTranslation("settings_more_free_apps"),
					img: getTranslation("image_settings_more_apps"),
                    href: appConfig.strings.moreAppsUrl,
					type: "link"
				},
				{
					name: getTranslation("settings_contact_us"),
					img: getTranslation("image_settings_contact_us"),
					href: getTranslation("settings_contact_us_href", [uid]),
					type: "link"
				},
				{
					name: getTranslation("settings_privacy_policy"),
					img: getTranslation("image_settings_privacy_policy"),
                    href: appConfig.strings.privacyPolicyUrl,
                    type: "link"
				},
				{
					name: getTranslation("settings_reset_game"),
					img: getTranslation("image_settings_reset"),
					type: "button",
					onClick: () => (addModalWindow(confirmResetDatabaseModal())),
					isLast: true
				},
			];
		};

		const getAccount = () => {
			if (isAnonymous) {
				return [
					{
						name: getTranslation("settings_login"),
						img: getTranslation("image_settings_login"),
						type: "button",
						onClick: () => (push(LOGIN_SCREEN)),
						isLast: true
					},
				]
			} else {
				return [
					{
						name: `${getTranslation("settings_logout")} (${displayName})`,
						img: avatar || getTranslation("image_settings_login"),
						placeholder: getTranslation("image_settings_login"),
						type: "button",
						onClick: () => (fsLogoutUser()),
						hasCircleImage: true
					},
					{
						name: getTranslation("settings_change_avatar"),
						img: getTranslation("image_settings_change_avatar"),
						type: "change-avatar"
					},
					{
						name: getTranslation("settings_change_password"),
						img: getTranslation("image_settings_change_password"),
						type: "button",
						onClick: () => (addModalWindow(confirmResetPasswordModal()))
					},
					{
						name: getTranslation("settings_delete_account"),
						img: getTranslation("image_settings_delete_account"),
						type: "button",
						onClick: () => (addModalWindow(confirmDeleteModal())),
						isLast: true
					},
				]
			}
		};

		const options = {getSocial, getOther, getAccount};

		return <SettingsScreen push={this.props.push}
							   addLoadingScreen={this.props.addLoadingScreen}
							   removeLoadingScreen={this.props.removeLoadingScreen}
		                       soundOnClick={soundOnClick}
		                       vibrateOnClick={vibrateOnClick}
		                       isDeviceAndroid={this.props.isDeviceAndroid}
		                       settings={settings} {...options} />;
	}
}
SettingsScreenContainer.propTypes = {
	settings: PropTypes.object.isRequired,
	isAnonymous: PropTypes.bool.isRequired,
	isDeviceAndroid: PropTypes.bool.isRequired,
	didSettingsChange: PropTypes.bool.isRequired,
	displayName: PropTypes.string,
	uid: PropTypes.string.isRequired,
	avatar: PropTypes.string,

	appConfig: PropTypes.shape({
		strings: PropTypes.shape({
			appUrlAndroid: PropTypes.string,
			appUrlIOS: PropTypes.string,
			facebookUrl: PropTypes.string,
			moreAppsUrl: PropTypes.string,
		}).isRequired,
	}).isRequired,

	toggleSound: PropTypes.func.isRequired,
	fsLogoutUser: PropTypes.func.isRequired,
	addModalWindow: PropTypes.func.isRequired,
	addLoadingScreen: PropTypes.func.isRequired,
	removeLoadingScreen: PropTypes.func.isRequired,
	push: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
	return {
		settings: state.userReducer.settings,
		uid: state.userReducer.uid,
		avatar: state.userReducer.user.avatar,
		appConfig: state.configReducer.appConfig,
		isAnonymous: state.userReducer.isAnonymous,
		displayName: state.userReducer.user.displayName,
		didSettingsChange: state.userReducer.didSettingsChange,
		isDeviceAndroid: state.configReducer.deviceConfig.isDeviceAndroid,
	};
}

export default connect(mapStateToProps, {
	toggleSound,
	toggleVibration,
	saveSettings,
	addModalWindow,
	fsLogoutUser,
	addLoadingScreen,
	removeLoadingScreen,
	mergeAndDeleteAnonymousUser,
	fsResetEmailPassword
})(SettingsScreenContainer);
